  // import * as echarts from 'echarts';
  import ReactEcharts from "echarts-for-react";
  import {convertDateFormat,breakTitle} from "../Custom/Custom"


  function BarChart({graphData,shortMonthToFull,chartDetails}) {

    const monthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];

    let payload=graphData[1].payload; 
    let UrbanConsumerGraphData=graphData[0].GroupCodes; 
    let chartDataLength= UrbanConsumerGraphData.length;
    let topFiveItemsObject={};
    let bottomFiveItemsObject={};
   

    if(chartDataLength>0){
      let currentMonthAndTop = [];
      let lastMonthAndTop = [];
      let lastYearAndTop = [];
      let heightYearAndTop= [];

      let currentMonthAndBottom = [];
      let lastMonthAndBottom = [];
      let lastYearAndBottom = [];
      let heightYearAndBottom = [];
      
      
      UrbanConsumerGraphData.forEach((monthData) => {
       
        if (Array.isArray(monthData)) {
           monthData.forEach((item) => {
           if (item.Top === "TOP") {

             if (item.Current_Month_Price !== undefined) {
                currentMonthAndTop.push(item);
              } else if (item.Last_Month_Price !== undefined) {
                lastMonthAndTop.push(item);
              } else if (item.Last_Year_Price !== undefined) {
                lastYearAndTop.push(item);
              } else if (item.Hight_Price !== undefined) {
                 heightYearAndTop.push(item);
              }
            }
            if (item.Bottom === "Bottom") {
  
              if (item.Current_Month_Price !== undefined) {
                currentMonthAndBottom.push(item);
              } else if (item.Last_Month_Price !== undefined) {
                lastMonthAndBottom.push(item);
              } else if (item.Last_Year_Price !== undefined) {
                lastYearAndBottom.push(item);
              } else if (item.Hight_Price !== undefined) {
                heightYearAndBottom.push(item);
              }
            }
          });
        }
      });
      
    currentMonthAndTop = currentMonthAndTop.sort((a, b) => a.Percentage - b.Percentage);

      //  Top 5 items code
      let currentMonthData = [];
      let topFiveToolTip=[]
      let topFiveyAxisData=[];
      let itemCodesArray = [];
      let topFiveItem='';
      currentMonthAndTop.forEach((item) => {
        currentMonthData.push({"value":item.Percentage
        ,"price":item.Current_Month_Price,"date":"00-00-0000"},);
        for(let i=0;i<heightYearAndTop.length;i++){
          if(item.ITEM_CODE===heightYearAndTop[i].ITEM_CODE){
            topFiveItem= item.ITEM_NAME_HINDI || item.ITEM_NAME;
            topFiveyAxisData.push(`${breakTitle(topFiveItem)}-${item.ITEM_CODE}  (${item.ITEM_UNIT_NAME}) \n High Value- Rs. ${heightYearAndTop[i].Hight_Price} \n (${convertDateFormat(heightYearAndTop[i].CREATEDDATE)})`  )
          }
          
        }
        itemCodesArray.push(item.ITEM_CODE);
        topFiveToolTip.push(`${topFiveItem}-${item.ITEM_CODE} (${item.ITEM_UNIT_NAME})`);
      })


    let lastMonthData = [];
    itemCodesArray.forEach((targetItemCode) => {
      const matchingItem = lastMonthAndTop.find(item => item.ITEM_CODE === targetItemCode);
  
      if (matchingItem) {
        lastMonthData.push({
              "value": matchingItem.Percentage,
              "price": matchingItem.Last_Month_Price,
              "date": "00-00-0000"
          });
      }
    }); 

    let lastYearData = [];
    itemCodesArray.forEach((targetItemCode) => {
      const matchingItem = lastYearAndTop.find(item => item.ITEM_CODE === targetItemCode);
  
      if (matchingItem) {
        lastYearData.push({
              "value": matchingItem.Percentage,
              "price": matchingItem.Last_Year_Price,
              "date": "00-00-0000"
          });
      }
    });

    currentMonthAndBottom = currentMonthAndBottom.sort((a, b) => b.Percentage - a.Percentage);

    //  bottom 5 items code
    let currentMonthDataBtoom = [];
    let bottomFiveToolTip=[];
    let bottomFiveyAxisData=[];
    let bottomitemCodesArray = [];
    let bottomFiveItem='';
    currentMonthAndBottom.forEach((item) => {
        currentMonthDataBtoom.push({"value":item.Percentage
        ,"price":item.Current_Month_Price,"date":"00-00-0000"},);

        for(let j=0;j<heightYearAndBottom.length;j++){
          if(item.ITEM_CODE===heightYearAndBottom[j].ITEM_CODE){
            bottomFiveItem =item.ITEM_NAME_HINDI || item.ITEM_NAME;
            bottomFiveyAxisData.push(`${breakTitle(bottomFiveItem)}-${item.ITEM_CODE}  (${item.ITEM_UNIT_NAME}) \n High Value- Rs. ${heightYearAndBottom[j].Hight_Price} \n (${convertDateFormat(heightYearAndBottom[j].CREATEDDATE)}) ` )
          }
        }
        bottomitemCodesArray.push(item.ITEM_CODE);
        bottomFiveToolTip.push(`${bottomFiveItem}-${item.ITEM_CODE} (${item.ITEM_UNIT_NAME})`);
       })

       let lastMonthDataBottom = [];
       bottomitemCodesArray.forEach((targetItemCode) => {
      const matchingItem = lastMonthAndBottom.find(item => item.ITEM_CODE === targetItemCode);
  
      if (matchingItem) {
        lastMonthDataBottom.push({
              "value": matchingItem.Percentage,
              "price": matchingItem.Last_Month_Price,
              "date": "00-00-0000"
          });
      }
    });  


    let lastYearDataBottom = [];
    bottomitemCodesArray.forEach((targetItemCode) => {
      const matchingItem = lastYearAndBottom.find(item => item.ITEM_CODE === targetItemCode);
  
      if (matchingItem) {
        lastYearDataBottom.push({
              "value": matchingItem.Percentage,
              "price": matchingItem.Last_Year_Price,
              "date": "00-00-0000"
          });
      }
    });

    const currentMonthIndex = monthNames.indexOf(shortMonthToFull(payload.month_name));
    const year=(currentMonthIndex===0) ?(payload.year_name-1):payload.year_name;//if month & Year is January  2020 then last Month December 2019 (current Year -1)
    const previousMonthIndex = (currentMonthIndex - 1 + 12) % 12;
    const previousMonthName = monthNames[previousMonthIndex];
    const currentMonthName=`Current Month (${shortMonthToFull(payload.month_name)} ${payload.year_name})`
    const lastMonthName=`Last Month (${previousMonthName} ${year})`
    const lastYearName=`Last Year (${shortMonthToFull(payload.month_name)} ${payload.year_name-1})`


    // Top Five Items Object 
    topFiveItemsObject = {
      title: {
        text: ''
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }, formatter: function(params) {
          let tooltipText = '';
          const dataIndex = params[0].dataIndex;
          const yAxisLabel = topFiveToolTip[dataIndex];
          tooltipText += yAxisLabel + '<br>';

          params.forEach(function(item) {
              
              const seriesName = item.seriesName;
              const value = item.value;
              const price = item.data.price;
            // Access the Y-axis label for the current data point
              tooltipText +=
                  '<div style="margin: 0px 0 0;line-height:1.8;"><span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:' +
                  item.color + ';"></span>' + seriesName + '  ' +
                  '<strong style="padding-left:30px;float:right;min-width:90px; ">' +
                  value + ' %</strong>' +
                  '<strong style="padding-left:30px;float:right"> Rs. ' +
                  price + '</strong></div>';

          });

          return tooltipText;
      }
      },
      legend: {},
      grid: {
        left: '5%',
        right: '5%',
        bottom: '15%',
        containLabel: true
      },
      toolbox: {
        show: true,
        feature: {
          saveAsImage: {}
        }
      },
      xAxis: [{
        type: 'value',
        name: 'Percentage',
        nameLocation: 'middle',
        nameGap: 70,
        boundaryGap: [0, 0.10],

        axisLabel: {
            formatter: '{value} % ',
            align: 'center',

            textStyle: {
                fontSize: '10',
            },
        },
    }],
    yAxis: {
        type: 'category',
        name: '',
        nameLocation: 'middle',
        nameGap: 140,
        axisLabel: {
          textStyle: {
              lineHeight: 15,
          },
      },
        data:topFiveyAxisData
    },
    series: [{
          name: currentMonthName,
          type: 'bar',
          data:currentMonthData
        },
        {
          name: lastMonthName,
          type: 'bar',
          data: lastMonthData
        },
        {
          name:  lastYearName,
          type: 'bar',
          data: lastYearData
        }
        ]
    };

    // Bottom Five Items Object 

    bottomFiveItemsObject = {
      title: {
        text: ''
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        },formatter: function(params) {
          let tooltipText = '';
          const dataIndex = params[0].dataIndex;
          const yAxisLabel = bottomFiveToolTip[dataIndex];
          tooltipText += yAxisLabel + '<br>';

          params.forEach(function(item) {

              const seriesName = item.seriesName;
              const value = item.value;
              const price = item.data.price;
            // Access the Y-axis label for the current data point
              tooltipText +=
                  '<div style="margin: 0px 0 0;line-height:1.8;"><span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:' +
                  item.color + ';"></span>' + seriesName + '  ' +
                  '<strong style="padding-left:30px;float:right;min-width:90px; ">' +
                  value + ' %</strong>' +
                  '<strong style="padding-left:30px;float:right"> Rs. ' +
                  price + '</strong></div>';

          });

          return tooltipText;
      }
      },
      legend: {},
      grid: {
        left: '5%',
        right: '5%',
        bottom: '15%',
        containLabel: true
      },
      toolbox: {
        show: true,
        feature: {
          saveAsImage: {}
        }
      },
      xAxis: [{
        type: 'value',
        name: 'Percentage',
        nameLocation: 'middle',
        nameGap: 70,
        boundaryGap: [0, 0.10],

        axisLabel: {
            formatter: '{value} % ',
            align: 'center',

            textStyle: {
                fontSize: '10',
            },
        },
    }],
    yAxis: {
        type: 'category',
        name: '',
        nameLocation: 'middle',
        nameGap: 140,
        axisLabel: {
          textStyle: {
              lineHeight: 15,
          },
      },
        data:bottomFiveyAxisData

    },
    series: [{
          name: currentMonthName,
          type: 'bar',
          data:currentMonthDataBtoom
        },
        {
          name: lastMonthName,
          type: 'bar',
          data: lastMonthDataBottom
        },
        {
          name: lastYearName,
          type: 'bar',
          data: lastYearDataBottom
        }
        ]
    };    
}

  return (
  <>

        <div className="px-3">
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-6 mb-4 mt-3">
            {chartDetails.chart_type==="Urban_Consumer_Chart" && 
            (`${payload.group_name} price (in Rs.) of Urban Consumer Retail Price Graph Report of current month, last month, last year, high Value with respect to corresponding current month and year (${shortMonthToFull(payload.month_name)} ${payload.year_name})`)
            }
            {chartDetails.chart_type==="Rular_Consumer_Chart" && 
            (`${payload.group_name} price (in Rs.) of Rural Consumer Retail Price Graph Report of current month, last month, last year, high Value with respect to corresponding current month and year (${shortMonthToFull(payload.month_name)} ${payload.year_name})`)
            }
          </div>
        </div>

        <div className="row">
              {/*Top 5 Items BarChart */}
              <div className="col-xl-6 col-lg-12 col-md-4 col-sm-12 mb-3 align-self-strech">
                <div className="card h-100"> 
                { (Object.keys(bottomFiveItemsObject).length) > 0 ?
                    <>
                    <div className="card-header bg-white">
                          <h6 className="fw-bold">Top 5 Items</h6>
                    </div>
                    <div className="card-body h-100">
                        {<ReactEcharts option={topFiveItemsObject} style={{ height: '600px', width: '100%' }} />}
                    </div>
                    </>
                    :
                    <h4 className="p-3 text-center text-danger fw-bold">Data Not Found</h4>
                  }
                  
                  </div>
                  
              </div>

              {/*bottom 5 Items BarChart */}
              <div className="col-xl-6 col-lg-12 col-md-4 col-sm-12 mb-3 align-self-strech">

                <div className="card h-100">
                  { (Object.keys(bottomFiveItemsObject).length) > 0 ?
                  <>
                    <div className="card-header bg-white">
                          <h6 className="fw-bold">Bottom 5 Items</h6>
                    </div> 
                    <div className="card-body h-100">
                      {
                      <ReactEcharts option={bottomFiveItemsObject} style={{height: '600px', width: '100%'}} />
                      }
                          
                  </div>
                  </>
                  :
                  <h4 className="p-3 text-center text-danger fw-bold">Data Not Found</h4>
                  }
                </div>
              </div>
        </div>
        </div>



  </>

  )
  }

  export default BarChart